import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Home, LogOut, Menu, X } from "lucide-react";
import { useAPI } from "../Context/MyContext";
import { useRef } from "react";
import { User } from "lucide-react";
import {
  FaRobot,
  FaUserFriends,
  FaTable,
  FaAddressBook,
  FaBullhorn,
  FaComments,
  FaWhatsapp,
  FaProjectDiagram,
} from "react-icons/fa";
// import logo from "../assets/new_logo2.png";
// import logo from "../assets/What_logo.png";
import logo from "../assets/What_logo878.png";
import Avatar from "./Avatar";

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(window.innerWidth >= 768);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const navigate = useNavigate();
  const location = useLocation(); // Track current route
  const { logoutUser, getAllowedFeatures } = useAPI();
  // const [user, setUser] = useState(null);
  // console.log("getAllowedFeatures::", getAllowedFeatures)
  const [profileOpen, setProfileOpen] = useState(false);
  const profileRef = useRef(null);
  const sidebarRef = useRef(null);
  const user = getAllowedFeatures;
  const initializedRef = useRef(false);

  // Handle responsive behavior
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);

      // Only set default ONCE 
      if (!initializedRef.current) {
        setIsOpen(!mobile);
        initializedRef.current = true;
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  // Close sidebar when clicking outside on mobile
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  useEffect(() => {
    const handleClickOutside = (e) => {
      if (profileRef.current && !profileRef.current.contains(e.target)) {
        setProfileOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Redirect if user not logged in
  // if (!user) {
  //   navigate("/");
  //   return null; // prevent rendering
  // }

  // Block access to features by hiding menu items
  const menuItems = [
    {
      name: "Dashboard",
      icon: <Home size={20} color="#4CAF50" />,
      href: "/dashboard",
    },
    {
      name: "Broadcasting",
      icon: <FaBullhorn size={20} color="#FF9800" />,
      href: "/Broadcasting",
      requiresFeature: "broadcasting",
    },
    {
      name: "Live Chat",
      icon: <FaComments size={20} color="#2196F3" />,
      href: "/ChatApp",
      requiresFeature: "liveChat",
    },
    {
      name: "Template",
      icon: <FaTable size={20} color="#2196F3" />,
      href: "/template",
    },
    {
      name: "Contact",
      icon: <FaAddressBook size={20} color="#2196F3" />,
      href: "/contacts",
      requiresFeature: "contacts",
    },
    {
      name: "Workflows",
      icon: <FaProjectDiagram size={20} color="#FF9800" />,
      href: "/workflow",
      requiresFeature: "workflows",
    },
    // Feature to integrate the WhatsApp API directly into the platform, allowing users to manage their WhatsApp business accounts, send messages, and view analytics without leaving the dashboard.
      {
      name: "WhatsApp API",
      icon: <FaWhatsapp size={20} color="#25D366" />,
      href: "/apis",
      requiresFeature: "api_access",
    },
    //  {
    //   name: "AI Assistant",
    //   icon: <FaRobot size={20} color="#9C27B0" />,
    //   href: "/ai-assistant",
    //   requiresFeature: "aiAssistant",
    // },
    //  {
    //   name: "Team Management",
    //   icon: <FaUserFriends size={20} color="#3F51B5" />,
    //   href: "/team-management",
    //   requiresFeature: "teamManagement",
    // },

  ];

  // Filter menu items based on user features
  // const filteredMenuItems = menuItems.filter((item) => {
  //   if (!item.requiresFeature) return true; // always show if no feature restriction
  //   return user.features?.[item.requiresFeature] === true;
  // });

  const filteredMenuItems = menuItems.filter((item) => {
    // If feature is required but user is not logged in → hide
    if (item.requiresFeature && !getAllowedFeatures) return false;
    // If feature is required and user exists → check feature flag
    if (item.requiresFeature) {
      return getAllowedFeatures.features?.[item.requiresFeature] === true;
    }
    // No feature required → always show
    return true;
  });

  const handleItemClick = (href) => {
    // Close sidebar on mobile when clicking a link
    if (isMobile) {
      setIsOpen(false);
    }

    // Navigate immediately without setTimeout to prevent blink
    if (href && href !== "#") {
      navigate(href);
    }
  };

  const handleOptionClick = () => {
    logoutUser();
    navigate("/");
  };

  // Check if route is active
  const isActiveRoute = (href) => {
    return location.pathname === href;
  };

  const handleManageProfile = () => {
    setProfileOpen(false);
    if (isMobile) setIsOpen(false);
    navigate("/manage-profile");
  };


  return (
    <>
      {/* Mobile Menu Toggle Button */}
      {isMobile && (
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="fixed top-4 left-4 z-50 p-2 bg-white rounded-lg shadow-lg md:hidden hover:bg-gray-100 transition"
        >
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      )}

      {/* Mobile Overlay */}
      {isMobile && isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
          onClick={() => setIsOpen(false)}
        />
      )}

      <div className="flex h-screen poppins-regular">
        <div
          ref={sidebarRef}
          className={`
              ${isOpen ? "w-64 md:w-56" : "w-0 md:w-16"} 
              ${isMobile ? "fixed left-0 top-0 h-full z-50" : "relative"}
              bg-[#F4F0EC] text-black flex flex-col transition-none shadow-lg
            `}
        >
          {/* Header */}
          <div
            className={`flex items-center p-4 ${isOpen ? "justify-between" : "justify-center"}`}
          >
            {/* Logo only shows when sidebar is open */}
            {isOpen && (
              <img
                src={logo}
                alt="Logo"
                className="w-[85%] h-auto m-1 pr-2 object-contain transition-opacity duration-300"
              />
            )}

            {/* Toggle Button */}
            {!isMobile && (
              <button
                onClick={() => setIsOpen(!isOpen)}
                className="text-gray-600 focus:outline-none hover:text-gray-800 transition"
              >
                {isOpen ? "◀" : "▶"}
              </button>
            )}
          </div>


          {/* Navigation */}
          <nav className="flex-1 overflow-y-auto p-2 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent">
            {filteredMenuItems.map((item, index) => (
              <div
                key={index}
                onClick={() => handleItemClick(item.href)}
                className={`
                    flex items-center gap-4 p-4 text-sm rounded-lg transition cursor-pointer mb-1
                    ${isActiveRoute(item.href)
                    ? "bg-green-500 text-white shadow-md"
                    : "hover:bg-green-100 hover:text-gray-800"
                  }
                    ${!isOpen && "justify-center md:justify-start"}
                  `}
              >
                <div className="flex-shrink-0">{item.icon}</div>
                <span
                  className={`${!isOpen && "hidden md:block"
                    } duration-200 font-medium truncate`}
                >
                  {item.name}
                </span>
              </div>
            ))}
          </nav>

          {/* Profile Section with Popup */}
          <div ref={profileRef} className="relative p-3 border-t border-gray-300">
            {/* Profile Button */}
            <button
              onClick={() => setProfileOpen(!profileOpen)}
              className={`flex items-center gap-3 w-full p-3 rounded-lg hover:bg-gray-200 transition ${!isOpen && "justify-center"
                }`}
            >
              {/* Avatar Wrapper */}
              {/* <div className="w-10 h-10 rounded-full overflow-hidden bg-green-500 flex items-center justify-center flex-shrink-0">
                {user?.profile_pic ? (
                  <img
                    src={user.profile_pic}
                    alt="profile"
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <span className="text-white font-semibold text-sm">
                    {user?.name?.[0]?.toUpperCase()}
                  </span>
                )}
              </div> */}
              {/* Avatar Wrapper */}
              <Avatar
                src={user?.profile_pic}
                name={user?.name}
                size={40}
                className="flex-shrink-0"
              />
              {isOpen && (
                <div className="text-left min-w-0">
                  <p className="text-sm font-medium truncate">{user?.name}</p>
                  {/* <p className="text-xs text-gray-500 truncate">{user?.email}</p> */}
                </div>
              )}
            </button>

            {/* Popup */}
            {profileOpen && (
              <div
                className={`
      absolute 
      ${isOpen ? "bottom-16 left-3 right-3" : "bottom-14 left-16 w-56"} 
      bg-white rounded-xl shadow-xl border z-50 p-4 space-y-2
    `}
              >
                {/* Manage Profile Button */}
                <button
                  onClick={handleManageProfile}
                  className="flex items-center gap-4 p-3 w-full text-sm rounded-lg transition cursor-pointer bg-gray-100 hover:bg-green-500 hover:text-white text-gray-700"
                >
                  <User size={20} />
                  <span className="font-medium">Manage Profile</span>
                </button>

                {/* Logout Button */}
                <button
                  onClick={handleOptionClick}
                  className="flex items-center gap-4 p-3 w-full text-sm rounded-lg transition cursor-pointer bg-red-50 hover:bg-red-500 hover:text-white text-red-600"
                >
                  <LogOut size={20} />
                  <span className="font-medium">Logout</span>
                </button>
              </div>
            )}


          </div>

          {/* Logout Button */}
          {/* <div className="p-2 border-t border-gray-300">
            <button
              onClick={handleOptionClick}
              className={`flex items-center gap-4 p-4 w-full text-sm rounded-lg transition cursor-pointer bg-red-50 hover:bg-red-500 hover:text-white text-red-600 ${!isOpen && "justify-center"
                }`}
            >
              <LogOut size={20} />
              <span className={`${!isOpen && "hidden"} duration-200 font-medium`}>
                Logout
              </span>
            </button>
          </div> */}  
        </div>
      </div>
    </>
  );
};

export default Sidebar;